import React from 'react'

const FAQPage = () => {
    return (
        <div>FAQ</div>
    )
}

export default FAQPage